import React, { useEffect } from 'react';
import './AppUsersPage.scss';
import Sidebar from '../../components/Sidebar/Sidebar';
import P4STable from '../../components/P4STable/P4STable';
import { columns, tableSetting, editParams, statisticsHeaders } from './consts';
import { useDispatch, connect } from 'react-redux';
import { requestGetUsersList, requestEditUser, clearUserError } from '../../store/users/actions';
import { getUsersList, getError } from '../../store/users/selectors';
import { AppState } from '../../store/rootReducer';
import { AppUsersPageProps, StatisticsDataRow } from './types';
import SnackbarMessage from '../../components/SnackbarMessage/SnackbarMessage';
import UserRoles from '../../resources/enums/UserRoles';
import ExportStatistics from '../../components/ExportStatistics/ExportStatistics';
import { getMissionsList } from '../../store/missions/selectors';
import { User } from '../../store/users/types';
import { UserMission, UserStage } from '../../store/users/types';
import { requestGetMissionsList } from '../../store/missions/actions';
import { Mission, Stage } from '../../store/missions/types';
import { getLanguagesList } from '../../store/languages/selectors';
import { requestGetList } from '../../store/languages/actions';
import { getDefaultLang } from '../../utils/LanguageHelper';

const AppUsersPage: React.FC<AppUsersPageProps> = (props) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(requestGetList());
        dispatch(requestGetUsersList([UserRoles.User, UserRoles.Master]));
        dispatch(requestGetMissionsList());
    }, []);

    editParams.handleSubmit = (data: object, setOpen: React.Dispatch<React.SetStateAction<boolean>>) => {
        const editData = data as { uid: string; role: string };
        dispatch(requestEditUser(editData.uid, editData.role));
        setOpen(false);
    };

    const getStatisticsData = () => {
        const data = [] as StatisticsDataRow[];
        props.users.forEach((user) => {
            if (!user.missions) return;
            user.missions?.forEach((mission) => {
                if (!mission.stages) return;
                const missionData = props.missions.find((x) => x.id === mission?.id);
                mission.stages.forEach((stage) => {
                    const stageData = missionData?.stages.find((x) => x.id === stage?.id);
                    if (!stageData) return;
                    data.push(getStatisticsItem(user, mission, stage, missionData, stageData));
                });
            });
        });
        return data;
    };

    const getStatisticsItem = (
        user: User,
        mission: UserMission,
        stage: UserStage,
        missionData?: Mission,
        stageData?: Stage,
    ) => {
        const lang = getDefaultLang(props.languages);
        return {
            uid: user.uid,
            userName: user.userName ?? '',
            missionName: missionData?.name[lang] ?? '',
            isStarted: mission.isStarted ?? false,
            isFinished: mission.isFinished ?? false,
            stagesCompleted: mission.doneCountStages ?? 0,
            stageName: stageData?.name[lang] ?? '',
            exercisesCompleted: stage.doneCountExercises,
            surveyCompleted: stage.surveyStatus ?? false,
        } as StatisticsDataRow;
    };

    const getTableData = () => {
        return props.users.map((user) => {
            return {
                uid: user.uid,
                userName: user.userName ?? '',
                email: user.email,
                master: user.master?.userName ? user.master?.userName : '',
                role: user.role,
            };
        });
    };

    return (
        <div>
            <Sidebar></Sidebar>
            <ExportStatistics data={getStatisticsData()} headers={statisticsHeaders}></ExportStatistics>
            <P4STable
                data={getTableData()}
                columns={columns}
                orderBy={tableSetting.orderBy}
                filterBy={tableSetting.filterBy}
                rowsPerPage={tableSetting.rowsPerPage}
                pages={tableSetting.pages}
                order={tableSetting.orderDirection}
                editParams={editParams}
            ></P4STable>
            <SnackbarMessage
                serverity="error"
                message={props.error}
                clearMessage={() => {
                    dispatch(clearUserError());
                }}
            ></SnackbarMessage>
        </div>
    );
};

function mapStateToProps(state: AppState) {
    return {
        users: getUsersList(state),
        missions: getMissionsList(state),
        error: getError(state),
        languages: getLanguagesList(state),
    };
}

export default connect(mapStateToProps)(AppUsersPage);
